import { render } from "./RegisterUser.vue?vue&type=template&id=38ede712&scoped=true"
import script from "./RegisterUser.vue?vue&type=script&lang=js"
export * from "./RegisterUser.vue?vue&type=script&lang=js"

import "./RegisterUser.vue?vue&type=style&index=0&id=38ede712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ede712"]])

export default __exports__